import { FC } from 'react';

import AccreditationApplicationTabs from './AccreditationApplicationTabs';
import { AccreditationTab } from './StepTypes';

type Props = {
  currentTab: AccreditationTab;
  onTabChange: (tab: AccreditationTab) => void;
  selectedInvestmentEntity: any | null;
  onProceedToSubmitStep: () => void;
  onBackStep: () => void;
  locked?: boolean;
};

const AccreditationApplicationStep: FC<Props> = ({
  currentTab,
  onTabChange,
  selectedInvestmentEntity,
  onProceedToSubmitStep,
  onBackStep,
  locked,
}) => {
  return (
    <div>
      <div className="rounded-md border border-gray-200 bg-white p-6">
        <h3 className="mb-1 text-base font-semibold">Step 2 – Accreditation Application</h3>
        <p className="mb-2 text-xs text-gray-600">
          Capture all information required to evaluate the investor&apos;s accredited status.
        </p>
        <AccreditationApplicationTabs
          currentTab={currentTab}
          onTabChange={onTabChange}
          selectedInvestmentEntity={selectedInvestmentEntity}
          onProceedToSubmitStep={onProceedToSubmitStep}
          onBackStep={onBackStep}
          locked={locked}
        />
      </div>
    </div>
  );
};

export default AccreditationApplicationStep;
